import dayjs from "dayjs";

interface outTime {
  label: string;
  value: string;
}

export const outTimes = () => {
  const times: outTime[] = [];

  for (let count = 0; count < 24; count += 1) {
    const suffix = count >= 12 ? "pm" : "am";
    let value = count > 12 ? count - 12 : count;

    if (count === 0) {
      value = 12;
    }

    times.push({
      label: dayjs(0).set("hour", count).format("LT"),
      value: `${value}${suffix}`,
    });
  }

  return times;
};

export default { outTimes };
